var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCilChevronDoubleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.516 173.771L368.537 282.792L448 203.329L338.979 94.308L339.02 94.267L270.872 26.118L266.544 21.818L259.544 14.733L259.477 14.8L191.326 82.953L179.988 94.374L71.033 203.329L150.5 282.792L259.516 173.771ZM214 105.622L225.334 94.2L259.449 60.085L259.49 60.126L259.557 60.059L293.765 94.267L293.724 94.308L402.745 203.329L368.537 237.537L259.516 128.516L150.5 237.537L116.293 203.329L214 105.622Z",
    className: "svgFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M338.953 315.408L270.872 247.327L259.583 236.121L259.475 236.013L191.326 304.161L180.054 315.517L71.033 424.538L150.5 504L259.516 394.979L368.537 504L448 424.538L338.912 315.45L338.953 315.408ZM402.745 424.538L368.537 458.745L259.516 349.724L150.5 458.745L116.293 424.538L214 326.831L225.256 315.491L259.521 281.226L293.837 315.542L293.796 315.583L402.745 424.538Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCilChevronDoubleUp);
export default __webpack_public_path__ + "static/media/cil_chevron-double-up.264fab1501f8e5267a9163af580038d4.svg";
export { ForwardRef as ReactComponent };